module.exports = __webpack_public_path__ + "static/media/java-intermediate.d6cef1e9.png";